<template>
  <div>
    <breadcrumbs :home="equipment.name+': Maintenance'"/>

    <v-card flat :loading="loading">
      <v-form ref="form">
        <v-container class="pt-6 px-6 purtrak-scrollable" fluid>
          <v-row v-if="equipment.maintenance.frequency && equipment.maintenance.frequencyUnits !== 'never'" class="mb-6">
            <v-col>Scheduled maintenance for {{equipment.maintenance.nextDate | formatDate}}</v-col>
          </v-row>
          <v-row v-if="equipment.maintenance.description">
            <v-col cols="6">
              <v-card outlined width="100%" class="pa-4 mb-6">
                {{equipment.maintenance.description}}
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="4" lg="3">
              <date-picker label="Completed" v-model="input.date" date-only/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="9" lg="6"><v-textarea label="Notes" v-model="input.notes" rows="3" outlined :counter="1000"/></v-col>
          </v-row>
        </v-container>
      </v-form>

      <v-divider/>
      <v-card-actions class="px-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="$router.back()">Cancel</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import {format} from 'date-fns'

export default {
  name: 'EquipmentMaintenance',
  props: {
    equipmentId: {type:String, required:true}
  },
  data () {
    return {
      saving: false,
      loading: false,
      equipment: {maintenance:{}},
      input: {id:'',date:format(new Date(), 'yyyy-MM-dd'),notes:''}
    }
  },
  async created() {
    this.loading = true;
    const results = await this.$apiCall(`query EquipmentMaintenance($id:ID!) {
                                            equipment(id:$id) {
                                              id,name,
                                              maintenance {frequency,frequencyUnits,nextDate,description}
                                            }
                                          }`,
                                        {id:this.equipmentId});
    if (results.error) {
      this.$nextTick(() => this.dirty = false);
      this.$router.back();
      return;
    }
    this.equipment = results.data.equipment;
    this.input.id = this.equipmentId;

    this.loading = false;
  },
  methods: {
    async save() {
      this.saving = true;
      const result = await this.$apiCall(`mutation EquipmentMaintenance($input:EquipmentPerformMaintenanceInput!) {
                                              equipmentPerformMaintenance(input:$input) {date}
                                            }`,
                                          {input:this.input});
      this.saving = false;
      if (!result.error) {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`Added maintenance record for ${this.equipment.name}`});
      }
    }
  }
}
</script>